import React, { useEffect } from 'react';
import FullPageCarousel from '../Components/Carousel/FullPageCarousel';
import ImageCard from '../Components/ImageCard/ImageCard';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './PageCss/HomePage.css';
import SectionHeader from '../Components/SectionHeader/SectionHeader';
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery hook
import Promoter from '../Components/Promoter/Promoter';
import FeatureCardCarousel from '../Components/FeaturesCardCarousal/FeatureCardCarousal'
import AOS from 'aos';
import 'aos/dist/aos.css';
import NumberGrid from '../Components/NumberGrid/NumberGrid';
import { useTranslation } from 'react-i18next';
import { useRegion } from '../contexts/RegionContext';
import { homePageContent } from '../data/regions/homePageContent';
import imgmark from '../assets/mark.png'
import imgHansaFlex_Kartons_Shop from '../assets/Home/HANSAFLEX_Kartons_Shop.webp';


import imgHANSAFLEX_Ireland_Hydraulic_parts from '../assets/Home/HANSAFLEX_Ireland_Hydraulic_parts.webp'
import imgHANSAFLEX_Ireland_Hose_fittings from '../assets/Home/HANSAFLEX_Ireland_Hose_fittings.webp'
import imgHANSAFLEX_Ireland_Valves from '../assets/Home/HANSAFLEX_Ireland_Valves.webp'
import imgHANSAFLEX_Ireland_Industrial_hoses from '../assets/Home/HANSAFLEX_Ireland_Industrial_hoses.webp'
import imgHANSAFLEX_Ireland_Pumps from '../assets/Home/HANSAFLEX_Ireland_Pumps.webp'
import imgHANSAFLEX_Ireland_Hydraulics_motors from '../assets/Home/HANSAFLEX_Ireland_Hydraulics_motors.webp'
import imgHANSAFLEX_Ireland_Quick_release_couplings from '../assets/Home/HANSAFLEX_Ireland_Quick_release_couplings.webp'
import imgHANSAFLEX_Ireland_Pneumatics from '../assets/Home/HANSAFLEX_Ireland_Pneumatics.webp'
import imgHANSAFLEX_IRELAND_Industries_Served_Collage from '../assets/Home/HANSAFLEX_Ireland_Industries_Served_Collage.webp'
import imgHFIrelandOnSiteHoseRepair from '../assets/Home/HANSAFLEX_Ireland_On_Site_Hose_Repair.webp'
import imgHANSAFLEX_Ireland_Hose_Assembly from '../assets/Home/HANSAFLEX_Ireland_Hose_Assembly.webp'
import imgHANSAFLEX_Ireland_Hydraulic_onsite_diagnostics_tests from '../assets/Home/HANSAFLEX_Ireland_Hydraulic_onsite_diagnostics_tests.webp'

import Horizontal from '../Components/Horizontal/Horizontal'


function HomePage() {
  const { i18n, t } = useTranslation();
  const { currentRegion } = useRegion();

  // Get region-specific content
  const regionContent = homePageContent[currentRegion];

  // var ingIndustries = ingIndustries_fr;
  // if (i18n.language === 'en') {
  //   ingIndustries = ingIndustries_en;
  // }

  const isLaptop = useMediaQuery({ minWidth: 1024 }); // Define the breakpoint for laptop screen size
  const isMobile = window.innerWidth <= 768;


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);


  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 320, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 300, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

    const featuresData = [
    {
      title: "High Quality",
      description: "We uphold the highest quality standards and are pleased to confirm this to our customers through our certificates.",
      image: imgmark
    },
    {
      title: "Diverse portfolio",
      description: "We offer a comprehensive product range, with everything available online as well.",
      image: imgmark
    },
    {
      title: "Smart maintenance tracking",
      description: "X‑CODE tagging helps reduce downtime and improve hose management.",
      image: imgmark
    },
        {
      title: "Extensive range of spare parts",
      description: "over 8,000 articles in stock, 10,000 articles available over night.",
      image: imgmark
    },

    // Add more objects for additional FeaturesCard data
  ];

  //promoter content

  const promoterTitle = 'PLACE YOUR ORDER TODAY!';
  const promoterChecklistItems = [
    'The full HANSA-FLEX product range with more than 80,000 articles',
    'Category-specific filter parameters enable quick navigation',
    'Current availability shown in real-time for better planning certainty'
  ];
  const promoterButtonLabels = ['CONTACT US', 'FIND OUT MORE !'];

  //hall of fame
  const numbers = ['3', '13+', '12000+'];
  const subtitles = ['Service vans', 'Employees', 'Line items in stock'];

  const googleReviewsLink = "https://www.google.com/maps/place/HANSA-FLEX+(NI)/@54.5442439,-6.0201206,17z/data=!3m1!5s0x486105d446aa92f9:0x6a6bc1471fdfdb04!4m8!3m7!1s0x4861a728a4066a45:0xc6c8deac667e23e2!8m2!3d54.5442439!4d-6.0201206!9m1!1b1!16s%2Fg%2F11g4j06f9c?entry=ttu&g_ep=EgoyMDI1MDYxNS4wIKXMDSoASAFQAw%3D%3D";


  return (
    <div>
      <FullPageCarousel />

     <div>
        <SectionHeader
          title={"Our Products"}
        />

        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={8} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Hydraulic_parts}
                learnMoreLink={"/hydraulic-hoses"}
                title={"Complete range of hydraulic parts"}
                desc={"Hydraulic hoses transfer fluid safely through the system. Their flexibility means they need very little installation space. The HANSA-FLEX range includes elastomeric and thermoplastic hoses with pressure carriers incorporating textile or steel braid or several inlays of spirally wound steel wire. This enables them to carry media at pressures of up to 500 bar. Hoses find use in numerous applications in mobile and stationary hydraulics."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Hose_fittings}
                learnMoreLink={"/hose-fitting"}
                title={"Hose fitting"}
                desc={"The fittings designed and manufactured by HANSA-FLEX are perfect for use with the appropriate hose type. They guarantee a safe and leak-free connection. The range includes all commonly called for nominal diameters and connection types and complies with international standards (BS, SAE, DIN and NF). The fittings are zinc-nickel coated and meet the highest requirements for durability and corrosion resistance."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Valves}
                learnMoreLink={"/ball-valves"}
                title={"Valves"}
                desc={"HANSA-FLEX ball valves are used to shut off and divert flow in hydraulic pipe systems at pressures of up to 500 bar and thus avoid need to convert or uninstall components. The valves have a floating ball between seals, which means they are low maintenance and have only low losses thanks to the large bore. HANSA-FLEX ball valves fulfil the requirements of all standards and safety regulations regarding strength and sealing performance."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Pumps}
                learnMoreLink={"/pumps"}
                title={"Pumps"}
                desc={"Hydraulic pumps are the heart of every hydraulic system. The build up the pressure in the system and take the energy of the oil to where it is needed. Our extensive range of gear and axial piston pumps in proven HANSA-FLEX quality covers a wide field of requirements in industrial and mobile hydraulics. Our product portfolio also contains radial piston and vane pumps for special applications."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Hydraulics_motors}
                learnMoreLink={"/hydraulic-motor"}
                title={"Hydraulic motors"}
                desc={"Hydraulic motors transform hydraulic energy into mechanical energy. We offer a wide range of geroller and gerotor motors matched to the performance data of your machines and systems in proven quality as premium or economy variants for numerous applications in mobile and industrial hydraulics. We can provide other types of hydraulic motors such as axial, gear and radial piston motors on request."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Quick_release_couplings}
                learnMoreLink={"/coupling"}
                title={"Quick release couplings "}
                desc={"Couplings are the best option in situations where attachments need to be quickly exchanged, machines safely connected or highly loaded hose lines on mobile and fixed hydraulic systems replaced. At HANSA-FLEX you can find quick release couplings perfect for your intended application in various materials such as steel or stainless steel and in a wide range of sizes and with various seal types."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Industrial_hoses}
                learnMoreLink={"/industrial-hoses"}
                title={"Industrial hoses"}
                desc={"Industrial hoses find application where the medium is not used for transmitting power. Industrial hoses transport a wide range of media from water and air through chemical substances right up to fuels and gases in almost every field of industry. In its specialist hose workshop, HANSA-FLEX fulfils the customer’s requirements to the highest standards of quality and shortest delivery schedules. You can find a wide choice of industrial hoses in the HANSA-FLEX online shop."}
              />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard
                image={imgHANSAFLEX_Ireland_Pneumatics}
                learnMoreLink={"/pneumatics"}
                title={"Pneumatic"}
                desc={"Pneumatics are at the heart of automated processes in logistics centres, small parts warehouses and the automotive industry. Compressed air is also used in vacuum technology and is indispensable for digital lifting and positioning operations. The quality and design of the components used make a crucial difference to the productivity and efficiency of pneumatic systems. HANSA-FLEX offers effective solutions and customised services."}
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div>
        <SectionHeader
          title="Our services"
        />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgHFIrelandOnSiteHoseRepair} learnMoreLink="/mobile-rapid-hydraulic-service" title="24/365 on site hose repair" desc="When hydraulic components fail unexpectedly, you need to act quickly. With 200 vehicles throughout Germany and 7 in Ireland, our Mobile Hydraulic Service (MHS) is always there for you, available 24 hours a day, 7 days a week and 365 days a year to minimize your downtimes. Our well-trained and experienced service technicians are with you within an hour. They correct defects, install replacement parts and manufacture custom hoses on site in their on-board workshop." />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgHANSAFLEX_Ireland_Hose_Assembly} learnMoreLink="/assembly-and-installation" title="Low and high-pressure Hose assemblies" desc="Our excellently trained service technicians carry out assembly and installation work on hydraulic systems. Irrespective of whether the work involves a stationary or a mobile unit, system design or practical implementation: You can benefit from the comprehensive range of products and services from our Industrial Service [Verlinkung LP “Industrieservice”] for all tasks to do with your hydraulic system." />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgHANSAFLEX_Ireland_Hydraulic_onsite_diagnostics_tests} learnMoreLink="/dguv-inspection" title="Hydraulic onsite diagnostic tests" desc="Hydraulic hose lines are fundamental components of machines and systems. They require comprehensive care and must be professionally inspected by authorised persons every 12 months after being brought into first use. HANSA FLEX takes care of the scheduling, performs the inspections and prepares the documentary record of the legally prescribed visual inspection and function test. This take some of the load off you the operator and increases the safety of your work equipment." />
            </Col>
          </Row>
        </Container>

      </div>

      {/* <div>
        <SectionHeader
          title="Explore our units!"
          paragraph="We have our units in Pune, which provide extensive range of products!"
        />
        <ShowcaseCarousel carouselItems={carouselItems} descDisplay={isMobile ? 'none' : 'block'} />
      </div>
      <br /><br /><br /> */}

      <div className='div-gray center-all-items'>
        <SectionHeader
          title="Advantages of HANSA-FLEX Ireland"
          subtitle=""
        />
        <FeatureCardCarousel featuresData={featuresData} />
      </div>


      <div>
        {isLaptop && (
          <Promoter
            title={promoterTitle}
            checklistItems={promoterChecklistItems}
            btnLabel1={"Find Out More !"}
            btnLabel1Link={"https://shop.hansa-flex.ie/"}
            imageUrl={imgHansaFlex_Kartons_Shop}
          />
          // TODO: contact us button
        )}
      </div>

      {/* <div>
        <SectionHeader
          title="News and Events" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/iree'} title="Operator protection – the right way!" desc={"Operator protection – the right way! From implementing stricter industrial health and safety regulations."} /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/product-training'} title="Size Matters: Calculating the Diameter of Hydraulic Hoses and Tubes" desc="Size Matters: Calculating the Diameter of Hydraulic Hoses and Tubes In hydraulic systems, choosing the correct inner diameter is essential." /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/goethe-event'} title="What you should know about hydraulic oils" desc="What You Should Know About Hydraulic Oils Hydraulic oils are an underrated component in plumbing systems. Many people simply." /></Col>
          </Row>
        </Container>
      </div> */}

      <div>
        <SectionHeader
          title={"HANSA-FLEX Ireland in numbers"} /><br />
        <NumberGrid numbers={numbers} subtitles={subtitles} /><br /><br />

      </div>

      <br /><br /><br />

      <div className="text-center div-gray">
        <SectionHeader
          title={"Check out our reviews on google!"}
          paragraph={"Curious about what others have to say about us? Take a moment to explore our Google reviews and discover why our customers rave about their experiences with us."} />
        <br />
        <Button variant="primary" href={googleReviewsLink} target="_blank" className="btn-google" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>{t("View our reviews on Google")}</Button>

        <br /><br /><br />
      </div>


      <br /><br /><br />

      <div>
        <SectionHeader title={"Industries served"} />
        <div className="home-imageContainer">
          {isMobile ? <>
            <img src={imgHANSAFLEX_IRELAND_Industries_Served_Collage} alt="HANSAFLEX_IRELAND_Industries_Served_CollageDescription of the image" className='home-img' />

          </> : <>
            <img src={imgHANSAFLEX_IRELAND_Industries_Served_Collage} alt="HANSAFLEX_IRELAND_Industries_Served_Collage" className='home-img' />

          </>}
        </div>

        <br /><br />

      </div>
      <div>
        {/* <SectionHeader
          title="News and Events" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgLocal} learnMoreLink={'/Local'} title="Local or imported stock? What weighs most in the operation?" /></Col>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgMeasurement} learnMoreLink={'/Measurement'} title="Essential Tools for Hydraulic Measurement" desc="" /></Col>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgLessHeadache} learnMoreLink={'/LessHeadache'} title="Less Headache with Maintenance Plans" desc="" /></Col>
           

          </Row>
        </Container> */}
      </div>

      <div>
        <Horizontal />
      </div>

    </div>

  );
}

export default HomePage;
